import { render, staticRenderFns } from "./PmLanding.vue?vue&type=template&id=2499f6f4&scoped=true&"
import script from "./PmLanding.vue?vue&type=script&lang=js&"
export * from "./PmLanding.vue?vue&type=script&lang=js&"
import style0 from "./PmLanding.vue?vue&type=style&index=0&id=2499f6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499f6f4",
  null
  
)

export default component.exports